import React from 'react';
import Navbar from '../components/Navbar';
import Hero from '../components/Hero';
import ValueCards from '../components/ValueCards';
import SocialProof from '../components/SocialProof';
import HowItWorks from '../components/HowItWorks';
import FlavorCircles from '../components/FlavorCircles';
import FunctionalShots from '../components/FunctionalShots';
import ComparisonTable from '../components/ComparisonTable';
import SpaSavingsCalculator from '../components/SpaSavingsCalculator';
import SplitSections from '../components/SplitSections';
import PricingStrip from '../components/PricingStrip';
import CustomerStories from '../components/CustomerStories';
import FAQ from '../components/FAQ';
import CTASection from '../components/CTASection';
import Footer from '../components/Footer';
import SEO from '../components/SEO';
const HomePage = () => {
  return <div className="flex flex-col min-h-screen bg-white" data-id="element-957">
      <SEO title="SmartSoda | Premium Spa Beverage Solutions | Enhance Guest Experience" description="Transform your spa beverage experience with SmartSoda's sustainable, wellness-focused, and profitable solutions. 29+ flavors, luxury presentation, and up to 60% profit margins." keywords="SmartSoda, spa beverages, wellness drinks, premium beverages, spa guest experience, medi spa, day spa, resort spa, spa revenue" data-id="element-958" />
      <Navbar data-id="element-959" />
      <main className="flex-grow" id="main-content" data-id="element-960">
        <Hero data-id="element-961" />
        <ValueCards data-id="element-962" />
        <SocialProof data-id="element-963" />
        <HowItWorks data-id="element-964" />
        <FlavorCircles data-id="element-965" />
        <FunctionalShots data-id="element-966" />
        <ComparisonTable data-id="element-967" />
        <SpaSavingsCalculator data-id="element-968" />
        <SplitSections data-id="element-969" />
        <PricingStrip data-id="element-970" />
        <CustomerStories data-id="element-971" />
        <FAQ data-id="element-972" />
        <CTASection data-id="element-973" />
      </main>
      <Footer data-id="element-974" />
    </div>;
};
export default HomePage;